import { jsx, jsxs } from "react/jsx-runtime";
import { Trigger, Button, ModalDialog, Box, Heading, Paragraph, Divider, Image } from "@zillow/constellation";
import { Anchor } from "@zillow/constellation-10";
import { useState, useRef } from "react";
import HubspotEmbed from "../HubspotEmbed/HubspotEmbed.esm.js";
function ContactSalesModal() {
  const [isPostSubmit, setIsPostSubmit] = useState(false);
  const preSubmitRef = useRef(null);
  const observerRef = useRef(null);
  const pollTimerRef = useRef(null);
  const cleanupWatchers = () => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (pollTimerRef.current) {
      window.clearInterval(pollTimerRef.current);
      pollTimerRef.current = null;
    }
  };
  const handleRefAttach = (node) => {
    cleanupWatchers();
    preSubmitRef.current = node;
    if (!node) return;
    const checkForPostSubmit = () => {
      if (node.querySelector(".hsfc-PostSubmit")) {
        setIsPostSubmit(true);
        cleanupWatchers();
        return true;
      }
      return false;
    };
    if (checkForPostSubmit()) return;
    observerRef.current = new MutationObserver(() => {
      checkForPostSubmit();
    });
    observerRef.current.observe(node, {
      childList: true,
      subtree: true
    });
    pollTimerRef.current = window.setInterval(() => {
      checkForPostSubmit();
    }, 500);
  };
  return /* @__PURE__ */ jsx(Trigger, { triggered: ({
    isOpen,
    onClose
  }) => /* @__PURE__ */ jsxs(ModalDialog, { "aria-label": "Contact Sales", className: "contact-sales-modal", id: "contact-sales-modal", isOpen, size: {
    default: ModalDialog.SIZES.FULL_SCREEN,
    md: ModalDialog.SIZES.SM
  }, style: {
    overflowY: "scroll",
    overscrollBehavior: "contain",
    WebkitOverflowScrolling: "touch",
    scrollbarColor: "#0000 #0000",
    scrollbarWidth: "none"
  }, onClose, children: [
    /* @__PURE__ */ jsxs(Box, { id: "contact-sales-modal-pre-submit", ref: handleRefAttach, sx: {
      display: isPostSubmit ? "none" : "flex",
      flexDirection: "column",
      padding: "$spacing.xl"
    }, children: [
      /* @__PURE__ */ jsx(Heading, { level: "4", marginBottom: "sm", textAlign: "center", children: "Don't miss out, join the Zillow Pro Interest List" }),
      /* @__PURE__ */ jsx(Paragraph, { marginBottom: "sm", textAlign: "center", children: "Discover what's next for Top Agents with updates on Zillow Pro - a membership that gives exclusive insights, tools, and visibility to engage leads and clients more intelligently." }),
      /* @__PURE__ */ jsx(Divider, { appearance: "regular", marginBottom: "sm" }),
      /* @__PURE__ */ jsx(HubspotEmbed, { region: "na1", portalId: "21555945", embedId: "196810036252", elementId: "hs-embed-196810036252-3niy6w" })
    ] }),
    /* @__PURE__ */ jsxs(Box, { id: "contact-sales-modal-post-submit", sx: {
      display: isPostSubmit ? "flex" : "none",
      flexDirection: "column",
      padding: "$spacing.xl"
    }, children: [
      /* @__PURE__ */ jsx(Image, { src: "https://www.zillowstatic.com/bedrock/app/uploads/sites/59/2025/10/artwork.png", attrs: {
        alt: "Decorative artwork graphic",
        src: "https://www.zillowstatic.com/bedrock/app/uploads/sites/59/2025/10/artwork.png"
      }, alt: "Decorative artwork graphic", style: {
        margin: "var(--spacing-sm)",
        alignSelf: "center"
      }, width: "144", height: "144", loading: "eager", decoding: "async" }),
      /* @__PURE__ */ jsx(Heading, { level: "4", marginTop: "sm", marginBottom: "sm", textAlign: "center", children: "Thank You!" }),
      /* @__PURE__ */ jsx(Paragraph, { marginBottom: "sm", textAlign: "center", children: "Our consultants from Zillow Group will call you in the next 1-2 business days." }),
      /* @__PURE__ */ jsx(Divider, { appearance: "regular", marginBottom: "sm" }),
      /* @__PURE__ */ jsx(Paragraph, { marginBottom: "sm", textAlign: "center", children: "During the call, we will discuss your business goals to see if Zillow is a good fit to help you achieve your growth target. If suitable, the next phase includes a free personalized Zillow Premier Agent package tailored to accelerate your business using our data to target the most active buyer markets." }),
      /* @__PURE__ */ jsx(Paragraph, { marginBottom: "sm", textAlign: "center", children: /* @__PURE__ */ jsx("strong", { children: "Ready to get started now?" }) }),
      /* @__PURE__ */ jsx(Box, { as: Anchor, href: "https://www.zillow.com/partners/industry-support/", style: {
        textAlign: "center",
        fontWeight: "$fontWeights.bodyHeading"
      }, children: "Explore tools to help navigate industry change" })
    ] })
  ] }), children: /* @__PURE__ */ jsx(Button, { as: "button", buttonType: "primary", id: "contact-sales-modal-button", "aria-label": "Contact Sales", className: "contact-sales-modal-button", style: {
    display: "none"
  }, type: "button", children: "Contact Sales" }) });
}
export {
  ContactSalesModal as default
};
